import Person from '@mui/icons-material/Person'
import RosterItemViewer from 'src/supportPortal/views/roster/component/viewers/RosterItemViewer'

export default function ClinicRosterItemViewer({ ...rest }) {
  return <RosterItemViewer {...rest} sidebarIcon={<Person />} />
}
